import type { ReactNode, SVGProps } from "react";

export function ErrorGlyphIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="10"
			viewBox="0 0 10 10"
			width="10"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5 1.75v4"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			/>
			<path
				d="M5 8.25h.01"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
			/>
		</svg>
	);
}
